<template>
  <div class="container module">
    <page-header type="image" :height="750" :image="banner">
      <template v-slot:searchbox>
        <div class="search-form">
          <div class="title">Catalogue</div>
          <el-input style="width: 350px" placeholder="Keywords"></el-input>
        </div>
      </template>
    </page-header>

    <div class="navi">
      <page-navbar class="inn" />
    </div>

    <filters
      :showFilter="showFilter"
      type="simple"
      :items="catalog_types"
      :total="total"
      @resetItems="resetItems"
      @searchItems="searchItems"
      @toggleStatus="toggleFilterFormStatus"
    >
    </filters>

    <catalogue-list :items="items" />

    <div class="section">
      <div class="loadmore" v-if="hasmore">
        <div class="btn" @click="loadMore">Load More</div>
      </div>
    </div>

    <page-footer />
  </div>
</template>
<style lang="scss" scoped>
.module {
  background-color: #fff;
}

.navi {
  position: relative;
  display: flex;
  justify-content: center;

  .inn {
    margin-top: -75px;
  }
}
</style>

<script>
import PageFooter from "../components/PageFooter.vue";
import PageHeader from "../components/PageHeaderV2.vue";
import PageNavbar from "../components/PageNavbar.vue";
import Filters from "../components/Filters.vue";
import CatalogueList from "../components/CatalogueList.vue";
import { mapGetters } from "vuex";

export default {
  name: "Catalog",
  components: {
    PageFooter,
    PageHeader,
    PageNavbar,
    Filters,
    CatalogueList,
  },
  computed: {
    ...mapGetters({
      catalog_types: "getCatalogTypes",
      getPageData: "getPageData",
    }),
    banner() {
      let key = "catalog";
      let page = this.getPageData;
      return !!page[key] ? page[key] : false;
    },
  },
  methods: {
    resetItems() {
      this.showFilter = false;
    },
    loadMore() {
      if (this.hasmore) {
        let pg = this.pg + 1;
        this.queryList({ pg });
      }
    },
    searchItems() {},

    toggleFilterFormStatus() {
      this.showFilter = !this.showFilter;
    },

    queryList(args) {
      Api.getCatalogList(args)
        .then((res) => {
          let items = this.items;
          this.items = items.concat(res.items);
          this.total = res.total;
          this.hasmore = res.hasmore;
          this.pg = Number(res.pg);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
  data() {
    return {
      showFilter: false,
      brand: "",
      total: 0,
      pg: 1,
      hasmore: false,
      items: [],
    };
  },
};
</script>
